module.exports = __webpack_public_path__ + "img/eshop.7229186b.png";